import { themes } from "./themes";

export const defaultTheme = themes.leaftech;

export const getActiveTheme = () => {
  const envTheme = process.env.REACT_APP_CLIENT_THEME;
  if (envTheme) return themes[envTheme] || defaultTheme;
  return defaultTheme;
};

export const getIsDefaultTheme = (themeName) => {
  return themeName === defaultTheme.name;
};
